import { z } from "zod";

export const companionsSchema = z.array(
    z.object({
        name: z.string().min(2, { message: "İsim En az 2 karakter olmalıdır." }).max(300),
        phone: z
            .string()
            .trim()
            .max(25)
            .optional()
            .refine((phone) => !phone || phone.length > 5, {
                message: "Telefon Numarası 5 karakterden uzun olmalıdır.",
            }),
    })
);

export const companionsFormSchema = z.object({
    companions: companionsSchema,
});

export type CompanionsSchema = z.infer<typeof companionsSchema>;
export type CompanionsFormSchema = z.infer<typeof companionsFormSchema>;
